import React, { useState } from 'react';
import { Box, Typography, Button, useTheme } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import RegistrationForm from './RegistrationForm';

const PreSaleBanner = () => {
  const [isFormOpen, setIsFormOpen] = useState(false);
  const theme = useTheme();

  return (
    <Box
      sx={{
        background: 'linear-gradient(45deg, #FFD700 30%, #FFA500 90%)',
        padding: '0.75rem',
        display: 'flex',
        flexDirection: { xs: 'column', sm: 'row' },
        alignItems: 'center',
        justifyContent: 'center',
        gap: { xs: '0.5rem', sm: '1rem' },
        color: '#1a237e',
        textAlign: 'center',
        borderRadius: '8px',
        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
        animation: 'glow 2s infinite alternate',
        '@keyframes glow': {
          '0%': {
            boxShadow: '0 2px 8px rgba(255, 215, 0, 0.3)',
          },
          '100%': {
            boxShadow: '0 2px 12px rgba(255, 215, 0, 0.6)',
          },
        },
      }}
    >
      <Typography
        variant="h6"
        component="div"
        sx={{
          fontWeight: 'bold',
          fontSize: { xs: '1rem', sm: '1.2rem' },
          textShadow: '0 1px 2px rgba(0, 0, 0, 0.1)',
        }}
      >
        Pre ITO release of Mummy and Daddy tokens
      </Typography>
      <Button
        variant="contained"
        color="secondary"
        onClick={() => setIsFormOpen(true)}
        sx={{
          mt: 1,
          px: 4,
          py: 1,
          fontSize: '1.1rem',
          fontWeight: 'bold',
          textTransform: 'none',
          borderRadius: 2,
          boxShadow: '0 0 10px rgba(255, 215, 0, 0.5)',
          '&:hover': {
            boxShadow: '0 0 15px rgba(255, 215, 0, 0.7)'
          }
        }}
      >
        Register Now!
      </Button>
      <RegistrationForm
        open={isFormOpen}
        onClose={() => setIsFormOpen(false)}
      />
    </Box>
  );
};

export default PreSaleBanner;
